<template>
  <div class="zy-nav" :style="{
 background: isNavTransparent ? '#00000000' : '#ffffff',
 color:isNavTransparent?'#fff':'#383838'
  }">
    <div class="zy-container ">
      <div class="nav-content" style="">
        <div class="logo-area" @click="goHome">
          <el-image class="navbar-brand" alt="" :src="isNavTransparent?require('@/assets/images/index/logo-3.gif'):require('@/assets/images/index/logo-2.gif')"
                    style="margin-right: 8px;height: 28px; width: 28px; cursor: pointer"/>
          <el-image :src=" isNavTransparent? require('@/assets/images/index/logo-title-3.png'): require('@/assets/images/index/logo-title.png')" class="logo-name" style=""/>
        </div>
        <div v-for="(menu, idx) in menus" :key="idx" :index="menu.path" class="menu-item" @mouseenter="enter(idx)" @mouseleave="leave" @click="onClick(idx)">
          <span>{{ menu.title }}</span>
          <div class="spin" v-if="idx==selectIndex">
            <div class="spin-show"></div>
          </div>
        </div>
        <div style="flex-grow: 1;"></div>
        <el-button @click="goLogin" type="primary" class="custom-btn">登录</el-button>
        <el-button @click="goLogin" class="custom-btn">免费试用</el-button>
      </div>
      <div class="panel panel-0" :style="{visibility:selectIndex==1?'visible':'hidden' ,transform:selectIndex==1?'rotate3d(0, 0, 0, 0deg)':'rotate3d(1, 0, 0, -90deg)'}" @mouseenter="enter(1)" @mouseleave="leave">
        <div class="zy-container panel-content">
          <div class="panel-title">CPS 商城云</div>
          <div class="btm-line"></div>
          <div class="nav-list">
            <div class="nav-item">
              <div class="nav-row" @click="goJump(item)" v-for="(item,index) in cpsList.navList1" :key="index">
                <div class="row-title">
                  {{ item.title }}
                </div>
                <div class="row-desc">
                  {{ item.subTitle }}
                </div>
              </div>
            </div>
            <div class="nav-item">
              <div class="nav-row" @click="goJump(item)" v-for="(item,index) in cpsList.navList2" :key="index">
                <div class="row-title">
                  {{ item.title }}
                </div>
                <div class="row-desc">
                  {{ item.subTitle }}
                </div>
              </div>
            </div>
            <div class="nav-item">
              <div class="nav-row" @click="goJump(item)" v-for="(item,index) in cpsList.navList3" :key="index">
                <div class="row-title">
                  {{ item.title }}
                </div>
                <div class="row-desc">
                  {{ item.subTitle }}
                </div>
              </div>
            </div>
            <div class="nav-item">
              <div class="nav-row" @click="goJump(item)" v-for="(item,index) in cpsList.navList4" :key="index">
                <div class="row-title">
                  {{ item.title }}
                </div>
                <div class="row-desc">
                  {{ item.subTitle }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  props: {
    fixed: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // 计算属性的 getter
    showPop: function () {
      return (this.selectIndex === 2 && this.inNav) || this.inPopver
    },
    navTransparent: function () {
      return this.isNavTransparent && !this.showPop && !this.inNav
    }
  },
  data() {
    return {
      selectIndex: -1,
      inNav: false,
      inPopver: false,
      isNavTransparent: true,
      // @/assets/images/index/logo-2.gif
      // @/assets/images/index/logo-3.png
      logo1: require('@/assets/images/index/logo.png'),
      logo2: require('@/assets/images/index/logo-3.png'),
      currentPath: '',
      cpsList: {
        navList1: [
          {
            title: '导购模块',
            subTitle: '提升下单率，消费更省钱',
            path: '/index/new-guide'
          },
          {
            title: '权益卡板块',
            subTitle: '一网打尽线上/下商城轻松赚佣金',
            path: '/index/new-card'
          },
          {
            title: '生活充值板块',
            subTitle: '超值优惠，72小时内到账',
            path: '/index/new-life'
          },
          {
            title: 'CPS出行板块',
            subTitle: '超值优惠',
            path: '/index/new-travel'
          },
          {
            title: 'CPS外卖板块',
            subTitle: '优惠劵等你抢',
            path: '/index/take-away'
          }
        ],
        navList2: [
          {
            title: 'CPS点餐板块',
            subTitle: '折扣多多',
            path: '/index/order'
          },
          {
            title: '供应链板块',
            subTitle: '轻松采购和分享您的商品',
            path: '/index/scm'
          },
          {
            title: '会员制商城板块',
            subTitle: '可设置各种制度',
            path: '/index/new-member-mall'
          },
          {
            title: '直播短视频',
            subTitle: '沉浸式购物，流量高效变现',
            path: '/index/new-live-video'
          },
          {
            title: '区块链任务板块',
            subTitle: '团队作战、能者多得',
            path: '/index/block-chain'
          }
        ],
        //
        navList3: [
          {
            title: '自营商城板块',
            subTitle: '品牌力强、产品质量可控',
            path: '/index/new-mall'
          },
          {
            title: 'O2O商城板块',
            subTitle: '无限生成独立小程序',
            path: '/index/new-o2o-mall'
          },
          {
            title: 'S2B2C商城板块',
            subTitle: '随时调整运营方案',
            path: '/index/new-b2c-mall'
          },
          {
            title: '短剧板块',
            subTitle: '海量优质短剧资源',
            path: '/index/short-play'
          },
          {
            title: '选品板块',
            subTitle: '轻松赚两份佣金',
            path: '/index/team-selection'
          }
        ],
        navList4: [
          {
            title: 'IM聊天板块',
            subTitle: 'IM聊天，纯自主研发',
            path: '/index/new-im'
          },
          {
            title: '云发单板块',
            subTitle: '支持发群 发朋友圈 跟发',
            path: '/index/cloud-issuance'
          },
          {
            title: '人工智能ChatGPT板块',
            subTitle: '协助您提高生活效率',
            path: '/index/chat-gpt'
          },
          {
            title: '广告任务板块',
            subTitle: '做任务，赚更多钱',
            path: '/index/new-advert'
          },
          {
            title: '游戏活动',
            subTitle: '吸粉裂变，运营的好工具',
            path: '/index/new-game'
          }
        ]
      },
      menus: [
        {
          title: '首页',
          path: '/'
        },
        {
          title: 'CPS·商城云',
          path: '/index/ability'
        },
        // {
        //   title: '食堂云',
        //   path: '/index/recommend'
        // }, {
        //   title: '点餐云',
        //   path: '/index/recommend'
        // }, {
        //   title: '收银云',
        //   path: '/index/recommend'
        // }, {
        //   title: '短剧云',
        //   path: '/index/recommend'
        // },
      ]
    }
  },
  mounted() {
    console.log(this.$route.path)
    this.currentPath = this.$route.path
    // 首页透明导航栏
    this.isNavTransparent = true
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
    goJump(item) {
      this.selectIndex = -1
      this.$router.push(item.path);
    },
    goLogin: function () {
      this.$router.push("/login");
    },
    handleJump: function (index, idx) {
      const item = this.items[index]
      if (item.list && item.list.length > 0) {
        const sub = item.list[idx]
        if (sub.path && sub.path.length > 0) {
          this.$router.push(sub.path);
          return
        }
      }
      if (item.path && item.path.length > 0) {
        this.$router.push(item.path);
        return
      }

    },
    handleScroll(e) {
      var scrollTop = e.target.documentElement.scrollTop || e.target.body.scrollTop;
      this.isNavTransparent = scrollTop < 100
    },
    onClick(index) {
      if (index == 0) {
        this.goHome()
      }
    },
    enter(index) {
      this.selectIndex = index
    },
    leave() {
      this.selectIndex = -1
    }
  }
}
</script>

<style scoped lang="scss">
.custom-btn {
  width: 100px;
  height: 38px;
  text-align: center;
  font-weight: 500;
}

.panel {
  position: absolute;
  z-index: 99000;
  top: 60px;
  left: 0;
  right: 0;
  padding-top: 0;
  transform: rotate3d(1, 0, 0, -90deg);
  transform-origin: 50% 0%;
  background-color: #fff;
  padding-bottom: 40px;
  border-bottom: 1px solid #e4e4e4;
  transition: transform 0.3s ease-in-out;
  visibility: hidden;

  .panel-content {
    padding-top: 43px;
    padding-left: 150px;
  }

  .panel-title {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    padding: 10px 10px 7px;
  }

  .btm-line {
    width: 170px;
    height: 1px;
    background: #C0D1FF;
    margin-bottom: 17px;
  }

  .panel-nav {
    color: red;
  }

  .nav-item {
    margin-right: 25px;
  }

  .nav-list {
    display: flex;
  }

  .nav-row {
    width: 220px;
    background: #FFFFFF;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 14px;
    cursor: pointer;

    .row-title {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
    }

    .row-desc {
      font-size: 13px;
      font-weight: 400;
      color: #838383;
    }
  }

  .nav-row:hover {
    background: #E9EFFF;
  }

}

.zy-nav {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99;

  .menu-item {
    font-size: 16px;
    font-weight: 500;
    margin-left: 30px;
    margin-right: 30px;
    cursor: pointer;
    height: 60px;
    line-height: 60px;
    position: relative;
  }

  .spin {
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
    justify-content: center;
    display: flex;
  }

  .nav-content {
    position: relative;
    display: flex;
    align-items: center;
    height: 60px;
  }

  .logo-area {
    display: flex;
    align-items: center;
  }


  .menu-item:hover, {
    color: #337eff;
  }

  .spin-show {
    width: 50px;
    height: 2px;
    background: #337eff;
  }
}

.logo-name {
  width: 90px;
  height: 19px;
  cursor: pointer;
}

</style>
